/* search-intel: fælles søgelogik (oprydning af søgeord, aliasser, "fører vi ikke", udsolgt sidst).
   Landedata (aliasser, populære søgninger, tekster) ligger i snippets/vejb-search-data.liquid → window.VEJB_SEARCH. */
(function () {
  var D = window.VEJB_SEARCH || {};
  var T = D.t || {};

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ø/g, 'o').replace(/ß/g, 'ss').replace(/æ/g, 'ae').replace(/ł/g, 'l')
      .replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // Fjerner støj kunder taster/indsætter: ² ¨ ' . , osv. Beholder 12/70, 3-12x56, 4,5mm.
  function clean(q) {
    var s = String(q || '').replace(/[²³¹⁰-⁹¨´`]/g, '');
    s = s.replace(/[^\p{L}\p{N}\s\-\/.,+]/gu, ' ');
    s = s.replace(/(^|\s)[.,\-\/+]+/g, '$1').replace(/[.,\-\/+]+(\s|$)/g, '$1');
    return s.replace(/\s+/g, ' ').trim();
  }

  // Aliasser: hele søgningen (alias) og enkeltord (tok). Nøgler er norm()-formen.
  function prepare(q) {
    var c = clean(q);
    var key = norm(c);
    if (D.alias && D.alias[key]) return D.alias[key];
    if (D.tok) {
      var parts = c.split(' ');
      var changed = false;
      for (var i = 0; i < parts.length; i++) {
        var r = D.tok[norm(parts[i])];
        if (r) { parts[i] = r; changed = true; }
      }
      if (changed) return parts.join(' ');
    }
    return c;
  }

  // Anonym egen måling (Hetzner soeg-maaler): ingen cookies/ID/IP — kun søgeord, antal, position, vare-handle.
  // KUN efter samtykke til statistik (Shopify Customer Privacy API, som Pandectes-banneret styrer). Uden samtykke sendes og gemmes intet. Slå helt fra: window.VEJB_MEASURE = false.
  function analyticsOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (err) { return false; }
  }
  var MURL = 'https://retur.jagtbutikken.com/intern/soeg';
  function measure(name, p) {
    try {
      if (window.VEJB_MEASURE === false || !p.term || String(p.term).length < 2 || !analyticsOk()) return;
      var body = JSON.stringify({ e: name, term: p.term, results: p.results, where: p.where, position: p.position, handle: p.handle, alt: p.alt, kind: p.kind });
      fetch(MURL, { method: 'POST', body: body, headers: { 'content-type': 'text/plain' }, keepalive: true, credentials: 'omit', mode: 'cors' }).catch(function () {});
    } catch (err) { /* måling må aldrig vælte søgningen */ }
  }

  // ---- Måling: dataLayer (GTM→GA4) + gtag hvis de findes. Navne: vejb_search_*  ----
  function track(name, p) {
    try {
      var e = Object.assign({ event: 'vejb_search_' + name, store_locale: D.locale || '' }, p || {});
      (window.dataLayer = window.dataLayer || []).push(e);
      if (typeof window.gtag === 'function') window.gtag('event', 'vejb_search_' + name, p || {});
      measure(name, p || {});
    } catch (err) { /* måling må aldrig vælte søgningen */ }
  }

  // ---- Ordgætning: ordforråd (assets/search-vocab.js, genereret pr. land) → hvilket ord er kunden på vej mod? Tåler stavefejl.
  var VSRC = (document.currentScript && document.currentScript.src || '').replace('search-intel.js', 'search-vocab.js');
  var VOC = null, VNORM = null, VSET = null, vocPromise = null;
  function loadVocab() {
    if (vocPromise) return vocPromise;
    vocPromise = new Promise(function (res) {
      var init = function () {
        if (window.VEJB_VOCAB && window.VEJB_VOCAB.length) {
          VOC = window.VEJB_VOCAB; VNORM = VOC.map(norm); VSET = Object.create(null);
          VNORM.forEach(function (w, idx) { if (!VSET[w]) VSET[w] = idx + 1; });
        }
        res();
      };
      var fromScript = function () {
        if (!VSRC) return res();
        var sc = document.createElement('script'); sc.src = VSRC; sc.onload = init; sc.onerror = function () { res(); };
        document.head.appendChild(sc);
      };
      if (window.VEJB_VOCAB) return init();
      // nyeste ordforråd (nat-værket skriver det som JSON i Shopify Files og peger på det via shop-metafelt) — ellers temaets egen fil
      if (window.VEJB_VOCAB_URL) {
        fetch(window.VEJB_VOCAB_URL).then(function (r) { return r.json(); }).then(function (arr) {
          if (arr && arr.length > 1000) { window.VEJB_VOCAB = arr; init(); } else { fromScript(); }
        }).catch(fromScript);
      } else { fromScript(); }
    });
    return vocPromise;
  }
  // Damerau-Levenshtein (ombytning af to bogstaver = 1 fejl, så "knvi" ligger tæt på "kniv"); afbrydes ved maxD
  function lev(a, b, maxD) {
    var la = a.length, lb = b.length, i, j;
    if (Math.abs(la - lb) > maxD) return maxD + 1;
    var m = [];
    for (i = 0; i <= la; i++) { m[i] = [i]; }
    for (j = 0; j <= lb; j++) m[0][j] = j;
    for (i = 1; i <= la; i++) {
      var rowMin = maxD + 1;
      for (j = 1; j <= lb; j++) {
        var c = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(m[i - 1][j] + 1, m[i][j - 1] + 1, m[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) v = Math.min(v, m[i - 2][j - 2] + 1);
        m[i][j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > maxD) return maxD + 1;
    }
    return m[la][lb];
  }
  // De mest sandsynlige ord kunden er på vej mod. Returnerer [{w, fuzzy}] i rangeret orden:
  // kuraterede ord (populære søgninger/forslag, også med 1 stavefejl) → præfiks-træf (rang = lager+salg) → ren stavefejl/ombytning (fuzzy).
  function complete(tok, max) {
    var k = norm(tok), i, scored = [], seen = {};
    if (!VNORM || k.length < 2) return [];
    var add = function (word, score, fuzzy) { if (!seen[word]) { seen[word] = 1; scored.push([score, word, fuzzy]); } };
    var pri = (D.popular || []).concat(D.suggest || []);
    // Clerk-søgninger indeholder ufærdige ord ("pannl", "hörselsky"): spring dem over, hvis de er præfiks af et populært ordforrådsord
    var curFragment = function (pn) {
      if (VSET[pn] && VSET[pn] - 1 <= 3000) return false;
      var lim = Math.min(VNORM.length, 4000);
      for (var j = 0; j < lim; j++) {
        if (VNORM[j].length > pn.length && VNORM[j].length - pn.length <= 5 && VNORM[j].indexOf(pn) === 0) return true;
      }
      return false;
    };
    for (i = 0; i < pri.length; i++) {
      var pn = norm(pri[i]);
      if (pn.indexOf(' ') > -1 || pn === k || curFragment(pn)) continue;
      if (pn.indexOf(k) === 0) add(pri[i], -1000 + i, false);
    }
    // afkortede ordrester ("pannl", "hörselsky") er præfiks af et langt mere populært ord → vis dem aldrig
    var isFragment = function (idx) {
      var wi = VNORM[idx];
      for (var j = 0; j < idx; j++) {
        var wj = VNORM[j];
        if (wj.length > wi.length && wj.length - wi.length <= 5 && wj.indexOf(wi) === 0 && idx > 3 * j + 300) return true;
      }
      return false;
    };
    var n = 0;
    for (i = 0; i < VNORM.length && n < 12; i++) {
      if (VNORM[i] !== k && VNORM[i].indexOf(k) === 0 && !isFragment(i)) { add(VOC[i], i <= 3000 ? i : 8000 + i, false); n++; }
    }
    if (k.length >= 4) {
      var maxD = k.length >= 7 ? 2 : 1, fz = [];
      for (i = 0; i < VNORM.length; i++) {
        var w = VNORM[i];
        if (w === k || seen[VOC[i]] || isFragment(i)) continue;
        var d = Math.min(lev(k, w.slice(0, k.length), maxD), lev(k, w, maxD));
        var same = w.charAt(0) === k.charAt(0);
        if (d <= maxD) fz.push([(k.length >= 5 && i < 1500 && d === 1 && same) ? 5000 + i : 20000 + i + d * 1000 + (same ? 0 : 5000), VOC[i]]);
      }
      fz.sort(function (x, y) { return x[0] - y[0]; });
      for (i = 0; i < fz.length && i < 6; i++) add(fz[i][1], fz[i][0], fz[i][0] >= 20000);
    }
    scored.sort(function (x, y) { return x[0] - y[0]; });
    return scored.slice(0, max).map(function (x) { return { w: x[1], fuzzy: x[2], s: x[0] }; });
  }
  // Plan for en søgning: hvad slår vi op (blandet af de mest sandsynlige ord), og hvilke ord vises som chips?
  function plan(term) {
    var c = clean(term), parts = c.split(' '), last = parts.pop(), k = norm(last);
    var res = { q: c, alts: [], words: [], completed: false, label: '' };
    if (!VNORM || k.length < 2) return res;
    var head = parts.length ? parts.join(' ') + ' ' : '';
    var comps = complete(last, 6);
    var good = comps.filter(function (x) { return !x.fuzzy; });
    var fuzz = comps.filter(function (x) { return x.fuzzy; });
    // et sjældent ord (lav rang, kort) tæller ikke som "færdigt": "pande" er på vej mod pandelampe/pandebånd
    var isWord = VSET[k] && (VSET[k] - 1 < 2500 || k.length >= 7);
    if (isWord) {
      res.alts = good.slice(0, 4).map(function (x) { return head + x.w; });
      return res;
    }
    var top = good.slice(0, 3);
    if (!top.length && fuzz.length) top = fuzz.filter(function (x) { return x.s - fuzz[0].s < 3000; }).slice(0, 2);
    if (!top.length) return res;
    res.completed = true;
    res.words = comps.slice(0, 5).map(function (x) { return head + x.w; });
    var terms = top.map(function (x) { return head + x.w; });
    if (head) terms = terms.slice(0, 1);
    // korte ord må ikke miste deres egne præfiks-træf ("sko"): tast-ordet med wildcard blandes ind
    // kun når det bedste gæt ikke er sikkert (lav rang i ordforrådet) blandes tast-ordet med wildcard ind, så korte ord ikke mister træf
    else if (top[0].s > 1500 || terms.length < 2) terms.push(last + '*');
    res.q = terms.join(' OR ');
    res.label = terms.join(', ').replace(/\*/g, '');
    res.alts = res.words;
    return res;
  }

  // ---- Redning: Shopify matcher ikke altid ufuldstændige ord ("pann" → 0 produkter, "pannelampe" → 10).
  // Prøver vores egne forslag og Shopifys søgeforslag i rækkefølge og returnerer det første der giver produkter.
  var rcache = {};
  function rescue(term) {
    var k = norm(term);
    if (k.length < 3) return Promise.resolve(null);
    if (rcache[k] !== undefined) return rcache[k];
    var cands = [];
    if (VNORM) { var pl0 = plan(term); if (pl0.completed) cands.push(pl0.q); }
    (D.suggest || []).forEach(function (w) {
      var n = norm(w);
      if (n !== k && (n.indexOf(k) === 0 || n.indexOf(' ' + k) > -1) && cands.length < 3) cands.push(w);
    });
    var getJson = function (u) { return fetch(u).then(function (r) { return r.json(); }); };
    rcache[k] = getJson('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=query&resources[limit]=4')
      .then(function (j) {
        ((j.resources && j.resources.results && j.resources.results.queries) || []).forEach(function (q) {
          if (norm(q.text) !== k && cands.length < 6) cands.push(q.text);
        });
      })
      .catch(function () { /* ingen forslag */ })
      .then(function () {
        var i = 0;
        var next = function () {
          if (i >= cands.length) return null;
          var c = cands[i++];
          return getJson('/search/suggest.json?q=' + encodeURIComponent(c) + '&resources[type]=product&resources[limit]=1')
            .then(function (j) { var p = (j.resources && j.resources.results && j.resources.results.products) || []; return p.length ? c : next(); })
            .catch(next);
        };
        return next();
      });
    return rcache[k];
  }

  window.vejbSearch = { norm: norm, clean: clean, prepare: prepare, data: D, track: track, rescue: rescue, loadVocab: loadVocab, plan: plan, complete: complete };

  // ---- /search-siden ----
  if (location.pathname !== '/search') return;
  var params = new URLSearchParams(location.search);
  var raw = params.get('q');
  if (!raw) return;

  // Udsolgt sidst på resultatsiden.
  var needsUpdate = false;
  if (!params.has('options[unavailable_products]')) { params.set('options[unavailable_products]', 'last'); needsUpdate = true; }
  var prepared = prepare(raw);
  if (!params.has('vejb_from') && prepared !== raw) {
    params.set('vejb_from', raw);
    params.set('q', prepared);
    needsUpdate = true;
  }
  if (needsUpdate) { location.replace('/search?' + params.toString()); return; }

  var from = params.get('vejb_from');
  var q = params.get('q');

  function box(html, cls) {
    var host = document.querySelector('.main-products-grid') || document.querySelector('main');
    if (!host || document.querySelector('.vejb-intel-note')) return;
    var b = document.createElement('div');
    b.className = 'vejb-nomatch vejb-intel-note' + (cls ? ' ' + cls : '');
    b.setAttribute('role', 'status');
    b.innerHTML = html;
    host.parentNode.insertBefore(b, host);
  }
  var esc = function (t) { return String(t).replace(/[<>&"]/g, ''); };

  function init() {
    // Måling + direkte træf (varenummer/EAN med præcis ét resultat → direkte til produktet).
    var links = document.querySelectorAll('.main-products-grid__results a[href*="/products/"]');
    var seen = {}, uniq = [];
    for (var i = 0; i < links.length; i++) {
      var h = links[i].getAttribute('href').split('?')[0];
      if (!seen[h]) { seen[h] = 1; uniq.push(h); }
    }
    var term = from || q;
    if (!uniq.length) {
      track('zero', { term: norm(term), where: 'page' });
      if (!from) {
        loadVocab().then(function () { return rescue(q); }).then(function (alt) {
          if (!alt) return;
          var p2 = new URLSearchParams(location.search);
          p2.set('q', alt); p2.set('vejb_from', q);
          track('rescue', { term: norm(q), alt: norm(alt), where: 'page' });
          location.replace('/search?' + p2.toString());
        });
      }
    } else {
      track('page', { term: norm(term), results: uniq.length, corrected: from ? 1 : 0 });
      if (uniq.length === 1 && /^[0-9a-z-/]{6,20}$/i.test(q.replace(/s/g, '')) && /d{4,}/.test(q) && sessionStorage.getItem('vejb-direct') !== q) {
        try { sessionStorage.setItem('vejb-direct', q); } catch (e) { /* ignore */ }
        track('direct', { term: norm(q) });
        location.replace(uniq[0]);
        return;
      }
    }
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('.main-products-grid__results a[href*="/products/"]');
      if (!a) return;
      var idx = Array.prototype.indexOf.call(links, a);
      track('click', { term: norm(term), where: 'page', position: idx + 1, handle: (a.getAttribute('href').split('/products/')[1] || '').split('?')[0] });
    });
    if (from && T.showing) {
      box('<p class="vejb-nomatch__s">' + T.showing.replace('{q}', '<strong>' + esc(q).replace(/ OR /g, ', ') + '</strong>').replace('{from}', esc(from)) + '</p>');
      var h1 = document.querySelector('main h1, .container h1');
      if (h1 && h1.textContent.indexOf(q) > -1) h1.textContent = h1.textContent.replace(q, from);
    }
    var nc = D.notCarried && D.notCarried[norm(q)];
    if (nc && T.notCarried) {
      box('<p class="vejb-nomatch__t">' + T.notCarried.replace('{q}', esc(q)) + '</p>' + (T.notCarriedSub ? '<p class="vejb-nomatch__s">' + T.notCarriedSub + '</p>' : ''));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
